/**
 * Given a `region`, return lazily the matching configuration.
 */
export async function getConfiguration(onboardingConfigurationId: string) {
  switch (onboardingConfigurationId) {
    /*** California ***/
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca":
      return (await import("./ca")).CaliforniaConfiguration;
    /** @deprecated please use `ca-ukg-swing-cert` instead */
    case "ca-ukg":
      return (await import("./ca-ukg")).CaliforniaUKGConfiguration;
    case "ca-ukg-swing-cert":
      return (await import("./ca-ukg-swing-cert")).CaliforniaUKGSwingCertConfiguration;
    case "ca-v4":
      return (await import("./ca-v4")).CaliforniaV4Configuration;
    /*** New Jersey ***/
    case "nj":
      return (await import("./nj")).NewJerseyConfiguration;
    /*** Fallback ***/
    default: {
      throw new Error(`No configuration found for ${onboardingConfigurationId}`);
    }
  }
}
